(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gb-buying-help"] && !Shopify.designMode) return;
  try {
    document.addEventListener('cart:update', (event) => {
  const data = event.detail && event.detail.data ? event.detail.data : {};
  if (data.didError || data.source !== 'product-form-component') return;
  document.querySelectorAll('[data-gb-view-cart]').forEach((link) => {
    link.hidden = false;
  });
  document.querySelectorAll('product-form-component .add-to-cart-button').forEach((button) => {
    const label = button.querySelector('.add-to-cart-text__content');
    if (!label) return;
    if (!button.dataset.gbCartBound) {
      button.dataset.gbCartBound = 'true';
      button.addEventListener('click', (event) => {
        if (button.dataset.goCart !== 'true') return;
        event.preventDefault();
        event.stopPropagation();
        const cartLink = document.querySelector('[data-gb-view-cart]');
        window.location.href = cartLink ? cartLink.href : '/cart';
      }, true);
    }
    label.textContent = 'Added to your cart';
    window.setTimeout(() => {
      label.textContent = 'View cart now';
      button.dataset.goCart = 'true';
    }, 2000);
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gb-collection-description"] && !Shopify.designMode) return;
  try {
    class GbCollectionCopy extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector('.gb-collection-copy__toggle');
    if (!button || button.dataset.bound === 'true') return;
    button.dataset.bound = 'true';
    button.addEventListener('click', () => {
      const collapsed = this.dataset.collapsed === 'true';
      this.dataset.collapsed = collapsed ? 'false' : 'true';
      button.textContent = collapsed ? button.dataset.less || 'Show less' : button.dataset.more || 'Read more';
    });
  }
}

if (!customElements.get('gb-collection-copy')) {
  customElements.define('gb-collection-copy', GbCollectionCopy);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gb-product-copy"] && !Shopify.designMode) return;
  try {
    class GbProductCopy extends HTMLElement {
  connectedCallback() {
    if (this.dataset.grouped === 'true') return;
    const body = this.querySelector('.gb-product-copy__body');
    if (!body) return;

    const children = Array.from(body.children);
    /** @type {{ title: string, nodes: Element[] }[]} */
    const groups = [];
    /** @type {{ title: string, nodes: Element[] } | null} */
    let current = null;
    /** @type {Element[]} */
    const preamble = [];

    children.forEach((element) => {
      const title = headingText(element);
      if (title) {
        current = { title, nodes: [] };
        groups.push(current);
        return;
      }
      if (current) current.nodes.push(element);
      else preamble.push(element);
    });

    const filled = groups.filter((group) => group.nodes.length > 0);
    if (filled.length < 2) return;

    const labels = {
      'product details': 'See what is included',
      'what is included': 'See what is included',
      'return & exchange policy': 'Exchange it within 7 days',
      'return and exchange': 'Exchange it within 7 days',
      'return policy': 'Exchange it within 7 days',
      'composition and care': 'Keep the fabric looking new',
      'fabric and care': 'Keep the fabric looking new',
      'fabric': 'See the fabric',
    };

    const wrapper = document.createElement('div');
    wrapper.className = 'gb-product-copy__groups';

    filled.forEach((group) => {
      const details = document.createElement('details');
      const key = group.title.toLowerCase();
      const summary = document.createElement('summary');
      summary.textContent = labels[key] || benefitTitle(group.title);
      const panel = document.createElement('div');
      group.nodes.forEach((node) => panel.append(node));
      details.append(summary, panel);
      wrapper.append(details);
    });

    const leadSource = preamble.length > 0 ? preamble : filled[0].nodes;
    const leadText = leadSource
      .map((node) => (node.textContent || '').replace(/\s+/g, ' ').trim())
      .filter(Boolean)
      .join(' ');

    const lead = document.createElement('p');
    lead.className = 'gb-product-copy__lead';
    lead.textContent = leadText;

    const more = document.createElement('button');
    more.type = 'button';
    more.className = 'gb-product-copy__more';
    more.textContent = 'Read the full details now';
    more.addEventListener('click', () => {
      const first = wrapper.querySelector('details');
      if (first instanceof HTMLDetailsElement) first.open = true;
      more.hidden = true;
      lead.style.webkitLineClamp = 'unset';
      lead.style.display = 'block';
    });

    children.forEach((element) => {
      if (headingText(element)) element.remove();
    });
    preamble.forEach((element) => element.remove());
    body.replaceChildren(lead, more, wrapper);
    this.dataset.grouped = 'true';
  }
}

/**
 * @param {string} title
 */
function benefitTitle(title) {
  const cleaned = title.replace(/[:.]+$/g, '').trim();
  if (/^(see|keep|exchange|order|wear|choose|know|get|read)\b/i.test(cleaned)) return cleaned;
  return `See ${cleaned.charAt(0).toLowerCase()}${cleaned.slice(1)}`;
}

/**
 * @param {Element} element
 * @returns {string}
 */
function headingText(element) {
  if (element.tagName !== 'P') return '';
  const text = element.textContent ? element.textContent.trim() : '';
  if (!text || text.length > 60) return '';
  const strong = element.querySelector('strong');
  if (strong) {
    const strongText = strong.textContent ? strong.textContent.trim() : '';
    return text === strongText ? text : '';
  }
  if (element.children.length > 0 || /[.!?]/.test(text)) return '';
  return text;
}

if (!customElements.get('gb-product-copy')) {
  customElements.define('gb-product-copy', GbProductCopy);
}
  } catch(e) { console.error(e); }
})();

})();
